












import {Component, Emit, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import AdminNavBar from './AdminNavBar.vue';
import {MAFUser} from '@/store/User/types';
import {Action, Mutation, Getter, namespace, State} from 'vuex-class';
import * as _ from 'lodash';
import {User} from 'firebase'; // @ is an alias to /src
import * as firebase from 'firebase/app';
import DocumentReference = firebase.firestore.DocumentReference;
import { friendState } from '../../store/Friends';

/* tslint:disable:no-empty */
/* tslint:disable:no-console */

const friendPath = 'friendState';
const friendNamespace = namespace(friendPath);
const userPath = 'userState';
const userNamespace = namespace(userPath);

@Component({
  components: {},
})
export default class BanUserModal extends Vue {
  @Prop() public readonly bannedUser!: MAFUser | undefined;
  @userNamespace.Action('setUserBan') public setUserBan!: any;

  public async onBanUser() {
    try {
      await this.setUserBan(this.bannedUser);
      this.close();
    } catch (error) {
      console.log(error);
    }
  }

  @Emit('close')
  public close() {
  }
}
